import { Box, styled } from "@/components";

const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  maxHeight: `calc(100vh - ${Number(theme.spacing(2).replace(/[^\d]/g, "")) + 100}px)`,
  overflowY: "auto",
  border: "unset",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1),
  "& > div": {
    paddingBottom: theme.spacing(1),
    "&:first-of-type": {
      paddingBottom: 0,
    },
  },
}));

export { StyledBox };
